import { useEffect, useState } from "react";

// Interfaces
import { IBasicModelSelector, IModelSelector } from "./interfaces";

// Hooks
import { useModelsByMake } from "@/Common/hooks/MakeModels";

// Helpers
import { getWildcardModels } from "@/Common/helpers/Brands";

// Layouts
import AgeOptions from "@/Layouts/components/AgeOptions";
import SmartSelector from "@/Layouts/components/InputComponents/SmartSelector";

// MUI
import Grid from "@mui/material/Grid";

export default function ModelSelector(props: Readonly<IModelSelector>) {
	const {
		make = "",
		model = "",
		modelYears = { rangeType: "RELATIVE", left: null, right: null },
		allowSpecificModels = false,
		useRegexModels = false,
		error = false,
		readOnly = false,
		onActionUpdate = () => {},
	} = props;

	const [actualModel, setActualModel] = useState<IBasicModelSelector>({
		make: "",
		model: "",
		modelYears: { rangeType: "RELATIVE", left: null, right: null },
	});

	const { models, isLoading } = useModelsByMake(actualModel?.make);

	const handleChangeModel = (currentModel?: Partial<IBasicModelSelector>) => {
		const updatedModel = { ...actualModel, ...currentModel };
		if (!currentModel) {
			updatedModel.model = "";
		}
		setActualModel(updatedModel);
		onActionUpdate(updatedModel);
	};

	const handleChangeYears = (currentModel: Partial<IBasicModelSelector>) => {
		const updatedModel = { ...actualModel, ...currentModel };
		setActualModel(updatedModel);
		onActionUpdate(updatedModel);
	};

	useEffect(() => {
		setActualModel({
			make,
			model,
			modelYears,
		});

		return () => {
			setActualModel({
				make: "",
				model: "",
				modelYears: { rangeType: "RELATIVE", left: null, right: null },
			});
		};
	}, [make, model, modelYears]);

	return (
		<Grid spacing={2} container sx={{ marginBottom: "5px" }}>
			<Grid item sx={{ width: "38.5%", paddingTop: allowSpecificModels ? "39px !important" : "0", marginRight: "10px" }}>
				<SmartSelector
					showBy={"model"}
					selectBy={"model"}
					options={getWildcardModels(models, useRegexModels) || []}
					selected={actualModel?.model ? { model: actualModel.model } : null}
					inputProps={{
						placeholder: "Model",
					}}
					listBoxProps={{
						sx: { maxHeight: "220px" },
					}}
					popperProps={{
						sx: { minWidth: "180px", maxWidth: "200px" },
					}}
					sx={{ minWidth: "100px" }}
					clearable
					disabled={readOnly}
					error={error}
					loading={isLoading}
					onChangeAction={(selection) => handleChangeModel(selection as IBasicModelSelector)}
				/>
			</Grid>

			<Grid item sx={{ width: "53.5%", marginLeft: "-5px" }}>
				<AgeOptions
					make={actualModel?.make}
					model={actualModel?.model}
					left={actualModel?.modelYears?.left}
					right={actualModel?.modelYears?.right}
					rangeType={actualModel?.modelYears?.rangeType || "RELATIVE"}
					useSwitch={allowSpecificModels}
					sxSwitch={{ marginTop: "-5px", marginLeft: "-167px" }}
					disabled={readOnly}
					error={error}
					clearable
					onActionUpdate={(updatedYears) => handleChangeYears({ modelYears: updatedYears })}
					sxLeft={{ width: "75px" }}
					sxRight={{ width: "75px" }}
					sxRelativeSeparator={{ padding: "0 5px" }}
				/>
			</Grid>
		</Grid>
	);
}
